import { render, staticRenderFns } from "./ProductButtonLightbox.vue?vue&type=template&id=149dfee2"
import script from "./ProductButtonLightbox.vue?vue&type=script&lang=js"
export * from "./ProductButtonLightbox.vue?vue&type=script&lang=js"
import style0 from "./ProductButtonLightbox.vue?vue&type=style&index=0&id=149dfee2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports